import { WidgetHeader as CommonWidgetHeader } from '../earnings-common/WidgetHeader'

function getCategoryLabel(category: string) {
  switch (category) {
    case 'products_and_services':
      return 'Products and Services'

    default:
      return category[0].toUpperCase() + category.substring(1)
  }
}

type WidgetHeaderProps = {
  category: string
}

export default function WidgetHeader({ category }: WidgetHeaderProps) {
  return <CommonWidgetHeader>Revenue by {getCategoryLabel(category)}</CommonWidgetHeader>
}
